
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#A0A5BA"}},[_c('path',{attrs:{"d":"M17.916 16.236a.666.666 0 00-.346-.639 9.388 9.388 0 01-4.686-6.264.666.666 0 00-.736-.52A5.128 5.128 0 009 10.443 5.146 5.146 0 005.18 8.76C2.276 8.759 0 11.507 0 15.014a10.212 10.212 0 002.358 7.066 15.25 15.25 0 00-.97 5.432 15.965 15.965 0 00.326 3.23A1.583 1.583 0 003.258 32a1.614 1.614 0 001.608-1.441c.343-3.137 2.12-5.503 4.134-5.503 2.014 0 3.79 2.366 4.133 5.504A1.614 1.614 0 0014.741 32a1.582 1.582 0 001.544-1.257c.218-1.063.328-2.145.327-3.23.01-1.854-.32-3.695-.97-5.432a9.661 9.661 0 002.274-5.845zM31.61 16.943a1.333 1.333 0 000-1.886l-3.124-3.122a.667.667 0 01-.102-.812 7.385 7.385 0 10-2.595 2.595.667.667 0 01.812.102l3.123 3.123a1.333 1.333 0 001.885 0zm-14.277-9.57a4.706 4.706 0 119.413 0 4.706 4.706 0 01-9.413 0z"}})])])
          )
        }
      }
    